(function ($) {
	$.eventRotator = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			EventRotator = (function ($c, o) {
				var defaults = {

				}; 

				var _o = {},

					ci = 0, // Current Index
				
					$e = null, // Events
					$p = null, // Previous Nav Link
					$n = null  // Next Nav Link
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					$e = $('.module-event-list__item', $c);
					$p = $('.module-event-list__navigation--item.prev', $c);
					$n = $('.module-event-list__navigation--item.next', $c);
				},

					_OnPrevClick = function(e) {
						e.preventDefault();

						var ind = ci - 1;
						if (ind < 0) {
							ind = $e.length - 1;
						}
						
						_ShowEventItem(ind);
					},

					_OnNextClick = function(e) {
						e.preventDefault();
						
						var ind = ci + 1;
						if (ind >= $e.length) {
							ind = 0;
						}

						_ShowEventItem(ind);
					},
					
						_ShowEventItem = function(ind) {
							$e.eq(ci).fadeOut(500);
							$e.eq(ind).fadeIn(500);
							ci = ind;
						},

				_BindEvents = function () {
					$p.click(_OnPrevClick);
					$n.click(_OnNextClick);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.eventRotator = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('eventRotator')) {
				var plugin = new $.eventRotator(this, options);
				$(this).data('eventRotator', plugin);
			}
		});
	};
})(jQuery);
